import { createPluginFactory } from "@udecode/plate-core";

export const ELEMENT_AUDIO = "audio";

export const createAudioPlugin = createPluginFactory<any>({
    key: ELEMENT_AUDIO,
    isElement: true,
    isVoid: true,
    then: (editor, { type }) => ({
        deserializeHtml: {
            rules: [
                {
                    validNodeName: "AUDIO",
                },
            ],
            getNode: (el) => ({
                type,
                // url: el.getAttribute('src'),
            }),
        },
    }),
});
